/* Copyright (c) 2021 Magnusson Institute, All Rights Reserved */
import React from 'react';
import { Grid, Grow, Typography } from "@mui/material";
import ProductCard from './ProductCard';
import { config } from 'config';

export interface Product {
    name: string,
    type: string,
    price: number,
    unit: string,
    image: string,
    description: string,
    product_id: string,
    checkout?: CallableFunction
}

export const products: Product[] = [
    {
        "name": "Storage",
        "type": "storage",
        "price": 33,
        "unit": "GB",
        "image": "/images/products/storage.png",
        "description": "The worlds most secure storage solution. Affordable, reliable, and fast with no reoccuring fees.",
        "product_id": config.products.storage,
    },
    // {
    //     "name": "VPN",
    //     "type": "vpn",
    //     "price": 12000,
    //     "unit": "Year",
    //     "image": "/images/products/vpn.png",
    //     "description": "A private, secure and anonymous US based VPN service. No logs, no tracking, no ads.",
    //     "product_id": config.products.vpn,
    // }

]


const Products = (props: {onCheckout: CallableFunction}) => {

    const checkout = (product_id: string) => {
        props.onCheckout(product_id)
    }

    return (
        <>
            <Grid item xs={12} sx={{ mb: 3 }}>
                <Typography variant="h6">
                    Products
                </Typography>
            </Grid>

            {products.map((product: Product, index) => {
                product.checkout = checkout
                return (
                    <Grow key={product.name + index} in={true} timeout={500 * (index + 1)}>
                        <Grid item xs={12} md={6} lg={4} sx={{ mb: 3 }}>
                            <ProductCard product={product} />
                        </Grid>
                    </Grow>
                )
            })}

        </>
    )
}

export default Products;


